import _ from "lodash"
import parsePhone from "./PhoneUtils"

export function appendSearch(search, additionalSearch) {
  if (!search || _.isEmpty(search.trim())) {
    return additionalSearch
  }
  if (!additionalSearch || _.isEmpty(additionalSearch.trim())) {
    return search
  }

  let params = []
  _.forEach(_.split(_.trimStart(additionalSearch, " ?"), "&"), (item) => {
    let keyValue = _.split(item, "=")
    if (keyValue.length === 2) {
      let key = keyValue[0].trim()
      let value = keyValue[1].trim()
      if (value && !_.isEmpty(value.trim()) && search.indexOf(`?${key}=`) < 0 && search.indexOf(`&${key}=`) < 0) {
        params.push(item.trim())
      }
    }
  })
  if (_.isEmpty(params)) {
    return search
  }

  return `${search}&${_.join(params, "&")}`
}

export function validParam(value) {
  if (typeof value === "string") {
    if (value !== "") {
      return value.trim()
    } else {
      return null
    }
  } else if (_.isArray(value)) {
    return _.map(value, (v) => validParam(v))
  } else {
    return value
  }
}

export function formatPhone(values) {
  return _.compact(
    _.map(values, (value) => {
      if (value) {
        const phone = parsePhone(value)
        if (!phone.error) {
          return phone.format()
        }
      }
      return null
    })
  )
}

export function phoneFormat(value) {
  if (value) {
    const phone = parsePhone(value)
    if (!phone.error) {
      return phone.format()
    }
  } else {
    return value
  }
}

export function isContain(permArray, permCode) {
  if (permArray instanceof Array) {
    return permArray.indexOf(permCode) > -1
  } else {
    return false
  }
}
